// extracted by mini-css-extract-plugin
export default {"container":"DisplayName_container__Ivvcj","title":"DisplayName_title__+Cbbf"};